import React from "react";
import {
  colors,
  radii,
  shadows,
  spacing
} from "./theme";

export default function Card({
  children,
  title,
  subtitle,
  actions,
  padding = "lg",
  hover = false,
  style = {}
}) {
  const paddingMap = {
    sm: spacing.sm,
    md: spacing.md,
    lg: spacing.lg,
    xl: spacing.xl,
    "2xl": spacing["2xl"]
  };

  return (
    <div
      style={{
        background: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: radii.lg,
        boxShadow: shadows.sm,
        padding: paddingMap[padding] || spacing.lg,
        transition: "all .2s ease",
        ...(hover
          ? {
              cursor: "pointer"
            }
          : {}),
        ...style
      }}
      onMouseEnter={(e) => {
        if (!hover) return;

        e.currentTarget.style.boxShadow = shadows.md;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        if (!hover) return;

        e.currentTarget.style.boxShadow = shadows.sm;
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {(title || subtitle || actions) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: spacing.lg
          }}
        >
          <div>
            {title && (
              <h3
                style={{
                  margin: 0,
                  color: colors.text,
                  fontSize: 20,
                  fontWeight: 700
                }}
              >
                {title}
              </h3>
            )}

            {subtitle && (
              <p
                style={{
                  marginTop: 6,
                  marginBottom: 0,
                  color: colors.textMuted,
                  fontSize: 14
                }}
              >
                {subtitle}
              </p>
            )}
          </div>

          {actions}
        </div>
      )}

      {children}
    </div>
  );
}